module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('agent-info'), _vm._v(" "), _c('cashflow', {
    attrs: {
      "source_id": _vm.agent_id,
      "sourceFn": "userCashflow",
      "label": "Agent",
      "name": _vm.agentProfile.name
    }
  }), _vm._v(" "), _c('agent-commissions', {
    attrs: {
      "agentProfile": _vm.agentProfile
    }
  }), _vm._v(" "), _c('agent-permissions'), _vm._v(" "), _c('agent-notes', {
    attrs: {
      "agent_id": _vm.$route.params.agent_id
    }
  }), _vm._v(" "), _c('agent-files', {
    attrs: {
      "agent_id": _vm.$route.params.agent_id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18ece06a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agents/AgentEdit.vue
// module id = 363
// module chunks = 0